let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("cEGXZ")]).then(() => parcelRequire('9rJL0'));